<template>

<form
  class="mx-auto col-sm-12"
  @submit.prevent
>
  <LDBsTable
    url="iccid"
    defaultSort="createdAt"
    defaultOrder="desc"
    :query="query"
    :columns="columns"
    :clear="clear"
    :defaultOptions='options'
  >
    <div class="form-group col-lg-6">
      <label for="serial">{{ $t('serial') }}</label>
      <input
        type="text"
        id="serial"
        name="serial"
        class="form-control"
        :placeholder="$t('ph_serial')"
        v-model="query.serial"
      >
    </div>

    <div class="form-group col-lg-6">
      <label for="iccid">ICCID</label>
        <input
          type="text"
          class="form-control"
          id="iccid"
          name="iccid"
          :placeholder="$t('ph_iccid')"
          v-model="query.iccid"
        >
    </div>
  </LDBsTable>

</form>

</template>

<script>
import LDBsTable from '@/components/shared/LDBsTable'
import Combobox from '@/components/shared/ComboBox'
import moment from 'moment'

const initialQuery = {
  serial   : '',
  iccid    : '',
  createdAt: ''
}

export default {
  name: 'UsersList',
  components: {
    LDBsTable,
    Combobox
  },
  
  data () {
    return {
      columns: [
        {
          title: this.$t('serial'),
          field: 'serial',
          sortable: true
        },
        {
          title: 'ICCID',
          field: 'iccid',
          sortable: true
        },
        {
          title: this.$t('createdAt'),
          field: 'createdAt',
          formatter: function(value) {
            return moment(value).format('DD/MM/YYYY HH:mm:ss')
          },
          sortable: true
        }
      ],
      options: {
        exportOptions: { fileName: 'iccid' }
      },
      query: Object.assign({}, initialQuery)
    }
  },
  
  methods: {
    clear() {
      this.query = Object.assign({}, initialQuery)
    }
  }
}

</script>